import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Lock, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Login() {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        login,
        senha
      });

      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      toast.success(`Bem-vindo, ${response.data.user.nome}!`);
      navigate('/');
    } catch (error) {
      console.error('Erro no login:', error);
      toast.error(error.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F7F8] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-sm border border-[#D1D5DB] p-8 w-full max-w-md">
        <div className="text-center mb-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_50c5aac3-6fba-43d7-bb53-da93d2f1d3d5/artifacts/5syieeve_ChatGPT%20Image%205%20de%20fev.%20de%202026%2C%2011_42_12.png"
            alt="Sistema de Receitas"
            className="h-[150px] w-auto mx-auto mb-5 object-contain"
          />
          <h1 className="text-2xl font-semibold text-[#1F2933] mb-1">Sistema de Receitas</h1>
          <p className="text-[#64748B] text-sm">Faça login para continuar</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="login" className="text-sm font-medium text-[#1F2933] mb-2 block">
              Email ou CPF
            </Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-[#64748B]" />
              <Input
                id="login"
                data-testid="login-input"
                value={login}
                onChange={(e) => setLogin(e.target.value)}
                placeholder="seu@email.com ou CPF"
                className="pl-10 bg-[#F4F7F8] border-[#D1D5DB] focus:border-[#0F766E] focus:bg-white transition-all rounded-lg h-11"
                required
              />
            </div>
          </div>

          <div>
            <Label htmlFor="senha" className="text-sm font-medium text-[#1F2933] mb-2 block">
              Senha
            </Label>
            <Input
              id="senha"
              data-testid="password-input"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="Digite sua senha"
              className="bg-[#F4F7F8] border-[#D1D5DB] focus:border-[#0F766E] focus:bg-white transition-all rounded-lg h-11"
              required
            />
          </div>

          <Button
            type="submit"
            data-testid="login-button"
            disabled={loading}
            className="w-full bg-[#0F766E] text-white hover:bg-[#0D6660] shadow-sm transition-all duration-200 rounded-lg h-11 text-base font-medium"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </Button>
        </form>

        <div className="mt-5 text-center">
          <button
            onClick={() => navigate('/register')}
            className="text-[#0F766E] hover:underline text-sm font-medium"
          >
            Não tem conta? Cadastre-se
          </button>
        </div>
      </div>
    </div>
  );
}